/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tag({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Activities/Content/Activity/ActivityType/Log/FromPart/Tag"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let activityTextpartsFromValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.from',
})
  return (<React.Fragment
>
<div
  data-testid="Tag.Horizontal"
  data-view-path={viewPath}
 style={{'--mr-1-mwk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 paddingTop={0}
 display="inline"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 display="inline"
 data="activity.textParts.from"
 text={activityTextpartsFromValueData}
/>
)}
</TysiaTag>
</div>
{children}
</React.Fragment>)
}